import {HIT_ORIGINS, TRACKING_EVENT_NAMES} from '../coches/tracking.js'

export const CATEGORIES = {
  SECOND_HAND: {
    imageSrc: 'https://s.ccdn.es/images/motos/home-categories-second-hand.png',
    name: 'HOME_CATEGORIES_MOTOS_SECOND_HAND',
    url: '/segunda-mano/'
  },
  NEW_VEHICLES: {
    imageSrc: 'https://s.ccdn.es/images/motos/home-categories-new-vehicles.png',
    name: 'HOME_CATEGORIES_MOTOS_NEWS',
    url: '/nuevas/'
  },
  SCOOTERS: {
    imageSrc: 'https://s.ccdn.es/images/motos/home-categories-scooters.png',
    name: 'HOME_CATEGORIES_MOTOS_SCOOTERS',
    url: '/segunda-mano/scooter/'
  },
  ON_ROAD: {
    imageSrc: 'https://s.ccdn.es/images/motos/home-categories-on-road.png',
    name: 'HOME_CATEGORIES_MOTOS_ON_ROAD',
    url: '/segunda-mano/carretera/'
  },
  MOPED: {
    imageSrc: 'https://s.ccdn.es/images/motos/home-categories-moped.png',
    name: 'HOME_CATEGORIES_MOTOS_MOPED',
    url: '/segunda-mano/ciclomotor/'
  },
  OFFROAD: {
    imageSrc: 'https://s.ccdn.es/images/motos/home-categories-offroad.png',
    name: 'HOME_CATEGORIES_MOTOS_OFFROAD',
    url: '/segunda-mano/off-road/'
  },
  CARS: {
    imageSrc: 'https://s.ccdn.es/images/motos/home-categories-cars.png',
    isExternal: true,
    name: 'HOME_CATEGORIES_MOTOS_CARS',
    url: 'https://www.coches.net/'
  }
}

export const HOME_CATEGORIES = [
  CATEGORIES.SECOND_HAND,
  CATEGORIES.NEW_VEHICLES,
  CATEGORIES.SCOOTERS,
  CATEGORIES.ON_ROAD,
  CATEGORIES.MOPED,
  CATEGORIES.OFFROAD,
  CATEGORIES.CARS
]

export const NEW_SEARCH_LITE_CATEGORIES_EXPERIMENT = []

export const BACKGROUND_IMAGE_URL_DESKTOP = 'motos/home-header-background-motos-desktop.jpg'
export const BACKGROUND_IMAGE_URL_MOBILE = 'motos/home-header-background-motos-mobile.jpg'
export const HOME_SELL_ACTIONS = [
  {
    imageUrl: 'https://s.ccdn.es/images/coches/pta/price-tag.svg',
    text: 'SELLER_SELECTOR.HERO_SELECTOR.PUBLISH_AD.TITLE.MOTOS',
    trackingInfo: {
      hitOrigin: HIT_ORIGINS.HOME_PAGE,
      eventName: TRACKING_EVENT_NAMES.ACCESS_TO_AD_INSERTION_CLICKED
    },
    url: '/publicar-mi-anuncio/categoria'
  },
  {
    imageUrl: 'https://s.ccdn.es/images/coches/pta/lightning-fast.svg',
    text: 'SELLER_SELECTOR.HERO_SELECTOR.INSTANT_OFFER.TITLE.MOTOS',
    trackingInfo: {
      hitOrigin: HIT_ORIGINS.HOME_PAGE,
      eventName: TRACKING_EVENT_NAMES.ACCESS_TO_INSTANT_OFFER_CLICKED
    },
    url: '/vender-mi-moto-a-un-profesional'
  }
]

export const PROMOTIONAL_BANNERS = []

export const PROMOTIONAL_BANNERS_SECTION_TITLE = 'HOME_PROMOTIONAL_BANNERS_TITLE_MOTOS'

export const ENABLE_GREEN_MOBILITY_SECTION = false
export const ENABLE_LIFESTYLE_CATEGORIES = false
export const ENABLE_PROMOTIONAL_BANNERS = true
export const ENABLE_MARKET_PLAYERS_SERVICES = false
